<template>
  <div class="lo">
    <div class="row col-md-12 m-0 p-0">
      <div class="col-md-8">
        <img src="../assets/login.svg" alt="" width="100%" />
      </div>
      <div class="col-md-4">
        <div class="form">
          <form class="login-form">
            <img src="../assets/banners/logo.svg" class="logo_img" alt="" />
            <p style="font-size:15px">-sales funnel and management.</p>
            <input type="text" v-model="username" placeholder="username" />
            <input
              type="password"
              v-on:keyup.enter="login()"
              v-model="password"
              placeholder="password"
            />
          </form>
          <button v-on:click="login()">
            <!-- <span v-if="!logging">Log in</span>
            <span v-else> Loading</span> -->
            <span>Log In</span>
          </button>
          <p class="mt-3" style="color:red;font-size:15px">{{ message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// const axios = require("axios");

export default {
  data() {
    return {
      message: "",
      username: "",
      password: "",
      logging: false,
    };
  }, 
  methods: {
    login() {
      this.logging = true;
      
        var user =   { username: this.username, password: this.password }
          
        this.$store.dispatch('AUTH_REQUEST', user)
        .then((res) => {
            localStorage.setItem("agent_id", res.id);
            localStorage.setItem("username", res.name);
            // localStorage.setItem("userImage", res);
            this.$store.dispatch('switchUser', {
              online: 1,
              notify: true
            })
            console.log(res)
            this.$router.push("/");
        })
        .catch((error) => {
          this.message = "Invalid Credentials";
          console.log(error.body)
          // this.logging = false;
        });
    },
  },
};
</script>
<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);

@media only screen and (max-width: 600px) {
  .form {
    margin: -20px auto 100px !important;
    background: transparent !important;
  }
}
.login-page {
  width: 360px;
  padding: 8% 0 0;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: 360px;
  margin: 20% auto 100px;
  padding: 45px;
  text-align: center;
  /* box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24); */
}
.form input {
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button {
  text-transform: uppercase;
  outline: 0;
  background: #4e44d8;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.form button:hover,
.form button:active,
.form button:focus {
  background: #43a047;
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color: #4caf50;
  text-decoration: none;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before,
.container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #ef3b3a;
}
body {
  background: #76b852; /* fallback for old browsers */
  background: -webkit-linear-gradient(right, #76b852, #8dc26f);
  background: -moz-linear-gradient(right, #76b852, #8dc26f);
  background: -o-linear-gradient(right, #76b852, #8dc26f);
  background: linear-gradient(to left, #76b852, #8dc26f);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
